<template>
  <v-container>
    <v-layout row>
      <v-flex>
        <div class="d-flex">
          <div class="perma-section-input pl-2">{{ input }}</div>
          <div>
            <v-btn
              class="ex-remove-btn w-100 ma-0 mb-2"
              @click="remove()"
              color="error"
              dark
              large
              >Remove Chain</v-btn
            >
            <div class="perma-section text-center pt-3 pb-3">{{ method }}</div>
            <div
              class="selector_chainlink list-group-item bg-primary text-white"
            >
              <div class="chin-edit">
                <v-btn
                  text
                  class="m-w chin-edit-icon"
                  @click="showLogicDialog()"
                >
                  <v-icon>edit</v-icon>
                </v-btn>
              </div>
              <div class="i-v-input">
                <div>Logic Block</div>
              </div>
            </div>
            <v-btn
              class="ex-add-btn w-100 ma-0 mt-2"
              @click="add()"
              color="success"
              dark
              large
              >Add Chain</v-btn
            >
          </div>
          <div class="perma-section-output pr-2">{{ output }}</div>
        </div>
      </v-flex>
    </v-layout>
    <!--    Dialog -->
    <v-dialog v-model="showLogicBlock" width="600">
      <v-card>
        <v-card-title class="headline" dark-title> Logic Block </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="mb-3">
          <ex-card disable-offsets>
            <template slot="header">
              <div class="button-cont">
                <v-btn @click="addExecution('if')">IF</v-btn>
                <v-btn @click="addExecution('function')">FUNCTION</v-btn>
                <v-btn @click="addExecution('path')">PATH</v-btn>
              </div>
              <v-divider></v-divider>
              <div class="col" v-for="(data, idx) in execution" :key="idx">
                <v-btn
                  icon
                  small
                  class="close-btn red accent-2"
                  @click="removeExecution(idx)"
                >
                  <v-icon>close</v-icon>
                </v-btn>
                <div v-if="data.type === 'path'">
                  <div class="row">
                    <label class="l-text">Source: </label>
                    <v-select
                      v-model="data.input.selection"
                      :items="data.input.options"
                      label="No selection"
                      class="ex-dropdown"
                      item-text="text"
                      solo
                    ></v-select>
                  </div>
                  <div v-if="data.input.selection === 'variables'" class="row">
                    <label class="l-text">Variable: </label>
                    <v-select
                      v-model="data.input.variables.selection"
                      :items="data.input.variables.options"
                      label="No selection"
                      class="ex-dropdown"
                      item-text="text"
                      solo
                    ></v-select>
                  </div>
                  <div
                    v-if="data.input.selection === 'db_properties'"
                    class="row"
                  >
                    <label class="l-text">db property: </label>
                    <v-select
                      v-model="data.input.db_properties.selection"
                      :items="data.input.db_properties.options"
                      label="No selection"
                      class="ex-dropdown"
                      item-text="text"
                      solo
                    ></v-select>
                  </div>
                  <div class="row">
                    <label class="l-text">Method: </label>
                    <v-select
                      v-model="data.extraction.selection"
                      :items="data.extraction.options"
                      label="No selection"
                      class="ex-dropdown"
                      item-text="text"
                      solo
                    ></v-select>
                  </div>
                  <div v-if="data.extraction.selection === 'dom'" class="row">
                    <v-text-field
                      v-model="data.extraction.objects.dom.body"
                      placeholder="Path"
                      class="input-text"
                    />
                    <v-text-field
                      v-model="data.extraction.objects.dom.value"
                      placeholder="Value"
                      class="input-text"
                    />
                    <v-text-field
                      v-model="data.extraction.objects.dom.occurence"
                      placeholder="Occurence"
                      class="input-text"
                    />
                    <div
                      v-if="data.extraction.objects.dom.output !== ''"
                      class="input-line"
                    >
                      Result:
                      {{ data.extraction.objects.dom.output }}
                    </div>
                  </div>
                  <div v-if="data.extraction.selection === 'regex'" class="row">
                    <v-text-field
                      v-model="data.extraction.objects.regex.delimiter"
                      placeholder="Delimiter"
                      class="input-text"
                    />
                    <v-text-field
                      v-model="data.extraction.objects.regex.body"
                      placeholder="Expression"
                      class="input-text"
                    />
                    <v-text-field
                      v-model="data.extraction.objects.regex.option"
                      placeholder="Options"
                      class="input-text"
                    />
                    <div
                      v-if="data.extraction.objects.regex.output !== ''"
                      class="input-line"
                    >
                      Result:
                      {{ data.extraction.objects.regex.output }}
                    </div>
                  </div>
                  <div v-if="data.extraction.selection === 'json'" class="row">
                    <div class="input-line">
                      <v-text-field
                        v-model="data.extraction.objects.json.body"
                        placeholder="Path"
                      />
                    </div>
                    <div
                      v-if="data.extraction.objects.json.output !== ''"
                      class="input-line"
                    >
                      Result:
                      {{ data.extraction.objects.json.output }}
                    </div>
                  </div>
                  <div class="row">
                    <label class="l-text">Exit: </label>
                    <v-select
                      v-model="data.exit.selection"
                      :items="data.exit.options"
                      label="No selection"
                      class="ex-dropdown"
                      item-text="text"
                      solo
                    ></v-select>
                  </div>
                  <div
                    v-if="data.exit.selection === 'applyFunction'"
                    class="row"
                  >
                    <v-select
                      v-model="data.exit.applyFunction.selection"
                      :items="data.exit.applyFunction.options"
                      label="No selection"
                      class="ex-dropdown"
                      item-text="text"
                      solo
                    ></v-select>
                    <div v-if="data.exit.applyFunction.output" class="row">
                      <span class="label">Exit: </span>
                      <v-select
                        v-model="data.exit.applyFunction.output.selection"
                        :items="data.exit.applyFunction.output.options"
                        label="No selection"
                        class="ex-dropdown"
                        item-text="text"
                        solo
                      ></v-select>
                      <div
                        v-if="
                          data.exit.applyFunction.output.selection ===
                          'variables'
                        "
                        class="row"
                      >
                        <v-select
                          v-model="
                            data.exit.applyFunction.output.variables.selection
                          "
                          :items="
                            data.exit.applyFunction.output.variables.options
                          "
                          label="No selection"
                          class="ex-dropdown"
                          item-text="text"
                          solo
                        ></v-select>
                      </div>
                      <div
                        v-if="
                          data.exit.applyFunction.output.selection ===
                          'page_output'
                        "
                        class="row"
                      >
                        <v-select
                          v-model="
                            data.exit.applyFunction.output.page_output.selection
                          "
                          :items="
                            data.exit.applyFunction.output.page_output.options
                          "
                          label="No selection"
                          class="ex-dropdown"
                          item-text="text"
                          solo
                        ></v-select>
                      </div>
                      <div
                        v-if="
                          data.exit.applyFunction.output.selection ===
                          'db_properties'
                        "
                        class="row"
                      >
                        <v-select
                          v-model="
                            data.exit.applyFunction.output.db_properties
                              .selection
                          "
                          :items="
                            data.exit.applyFunction.output.db_properties.options
                          "
                          label="No selection"
                          class="ex-dropdown"
                          item-text="text"
                          solo
                        ></v-select>
                      </div>
                      <div
                        v-if="
                          data.exit.applyFunction.output.selection ===
                          'page_output'
                        "
                        class="row"
                      ></div>
                    </div>
                  </div>
                </div>
                <div v-if="data.type === 'if'">
                  <div class="row">
                    <label class="l-text">Source: </label>
                    <v-select
                      v-model="data.input.selection"
                      :items="data.input.options"
                      label="No selection"
                      class="ex-dropdown"
                      item-text="text"
                      solo
                    ></v-select>
                  </div>
                  <div v-if="data.input.selection === 'variables'" class="row">
                    <v-select
                      v-model="data.input.variables.selection"
                      :items="data.input.variables.options"
                      label="No selection"
                      class="ex-dropdown"
                      item-text="text"
                      solo
                    ></v-select>
                  </div>
                  <div
                    v-if="data.input.selection === 'db_properties'"
                    class="row"
                  >
                    <v-select
                      v-model="data.input.db_properties.selection"
                      :items="data.input.db_properties.options"
                      label="No selection"
                      class="ex-dropdown"
                      item-text="text"
                      solo
                    ></v-select>
                  </div>
                  <div class="row">
                    <label class="l-text">Condition: </label>
                    <v-select
                      v-model="data.condition.selection"
                      :items="data.condition.options"
                      label="No selection"
                      class="ex-dropdown"
                      item-text="text"
                      solo
                    ></v-select>
                  </div>
                  <div
                    v-if="data.condition.selection === 'is_bigger'"
                    class="row"
                  >
                    <v-text-field
                      v-model="data.condition.objects.is_bigger.value"
                      placeholder="Value"
                    />
                  </div>
                  <div
                    v-if="data.condition.selection === 'is_less'"
                    class="row"
                  >
                    <v-text-field
                      v-model="data.condition.objects.is_less.value"
                      placeholder="Value"
                    />
                  </div>
                  <div
                    v-if="data.condition.selection === 'contains'"
                    class="row"
                  >
                    <v-text-field
                      v-model="data.condition.objects.contains.value"
                      placeholder="Value"
                    />
                  </div>
                  <div
                    v-if="data.condition.selection === 'not_contains'"
                    class="row"
                  >
                    <v-text-field
                      v-model="data.condition.objects.not_contains.value"
                      placeholder="Value"
                    />
                  </div>
                  <div class="row">
                    <label class="l-text">Exit: </label>
                    <v-select
                      v-model="data.exit.return.selection"
                      :items="data.exit.return.options"
                      label="No selection"
                      class="ex-dropdown"
                      item-text="text"
                      solo
                    ></v-select>
                  </div>
                  <div
                    v-if="data.exit.return.selection === 'applyFunction'"
                    class="row"
                  >
                    <label class="l-text">Function: </label>
                    <v-select
                      v-model="data.exit.return.applyFunction.selection"
                      :items="data.exit.return.applyFunction.options"
                      label="No selection"
                      class="ex-dropdown"
                      item-text="text"
                      solo
                    ></v-select>
                  </div>
                  <div class="row">
                    <label class="l-text">Data: </label>
                    <v-select
                      v-model="data.exit.selection"
                      :items="data.exit.options"
                      label="No selection"
                      class="ex-dropdown"
                      item-text="text"
                      solo
                    ></v-select>
                  </div>
                  <div v-if="data.exit.selection === 'bool'" class="row">
                    <label class="l-text">bool selection: </label>
                    <v-select
                      v-model="data.exit.objects.bool.selection"
                      :items="data.exit.objects.bool.options"
                      label="No selection"
                      class="ex-dropdown"
                      item-text="text"
                      solo
                    ></v-select>
                  </div>
                  <div v-if="data.exit.selection === 'variable'" class="row">
                    <v-select
                      v-model="data.exit.objects.variable.selection"
                      :items="data.exit.objects.variable.options"
                      label="No selection"
                      class="ex-dropdown selector"
                      item-text="text"
                      solo
                    ></v-select>
                  </div>
                  <div
                    v-if="data.exit.selection === 'db_properties'"
                    class="row"
                  >
                    <v-select
                      v-model="data.exit.objects.db_properties.selection"
                      :items="data.exit.objects.db_properties.options"
                      label="No selection"
                      class="ex-dropdown selector"
                      item-text="text"
                      solo
                    ></v-select>
                  </div>
                  <div v-if="data.exit.selection === 'string'" class="row">
                    <v-text-field
                      v-model="data.exit.objects.string.selection"
                      placeholder="Value"
                    />
                  </div>
                </div>
                <div v-if="data.type === 'function'" class="row">
                  <label class="l-text"></label>
                  <v-select
                    v-model="data.methods.selection"
                    :items="data.methods.options"
                    label="No selection"
                    class="ex-dropdown"
                    item-text="text"
                    solo
                  ></v-select>
                  <div
                    v-if="
                      data.methods.selection === 'prepend' ||
                      data.methods.selection === 'append'
                    "
                    class="row"
                  >
                    <v-text-field
                      v-model="data.methods.objects.aprend"
                      placeholder="Value"
                    />
                  </div>
                  <div
                    v-if="data.methods.selection === 'seller_switch'"
                    class="row"
                  >
                    <v-text-field
                      v-model="data.methods.objects.seller_switch"
                      placeholder="Value"
                    />
                  </div>
                  <div v-if="data.methods.selection === 'truncate'" class="row d-flex justify-content-around">
                    <v-layout row="false">
                      <v-flex>
                        <v-text-field name="truncate-target" label="target" v-model="data.methods.objects.truncate.target" />
                      </v-flex>
                      <v-flex>
                       <v-text-field name="truncate-target_position" label="target_position" v-model="data.methods.objects.truncate.target_position" />
                      </v-flex>
                      <v-flex>
                        <v-text-field name="truncate-length" label="length" v-model="data.methods.objects.truncate.target" />
                      </v-flex>
                    </v-layout>
                  </div>
                  <div v-if="data.methods.selection === 'multiply'" class="row">
                    <span class="label">Source: </span>
                    <v-select
                      v-model="data.methods.objects.multiply.input1"
                      :items="data.input.options"
                      label="No selection"
                      class="ex-dropdown"
                      item-text="text"
                      solo
                    ></v-select>
                    <div
                      v-if="
                        data.methods.objects.multiply.input1 === 'variables'
                      "
                      class="row"
                    >
                      <v-select
                        v-model="data.methods.objects.multiply.value1"
                        :items="data.input.variables.options"
                        label="No selection"
                        class="ex-dropdown"
                        item-text="text"
                        solo
                      ></v-select>
                    </div>
                    <div
                      v-if="
                        data.methods.objects.multiply.input1 === 'db_properties'
                      "
                      class="row"
                    >
                      <v-select
                        v-model="data.methods.objects.multiply.value1"
                        :items="data.input.db_properties.options"
                        label="No selection"
                        class="ex-dropdown"
                        item-text="text"
                        solo
                      ></v-select>
                    </div>
                    <div
                      v-if="data.methods.objects.multiply.input1 === 'string'"
                      class="row"
                    >
                      <v-text-field
                        v-model="data.methods.objects.multiply.value1"
                        placeholder="Value"
                      />
                    </div>
                    <span class="label">Multiply By: </span>
                    <v-select
                      v-model="data.methods.objects.multiply.input2"
                      :items="data.input.options"
                      label="No selection"
                      class="ex-dropdown"
                      item-text="text"
                      solo
                    ></v-select>
                    <div
                      v-if="
                        data.methods.objects.multiply.input2 === 'variables'
                      "
                      class="row"
                    >
                      <v-select
                        v-model="data.methods.objects.multiply.value2"
                        :items="data.input.variables.options"
                        label="No selection"
                        class="ex-dropdown"
                        item-text="text"
                        solo
                      ></v-select>
                    </div>
                    <div
                      v-if="
                        data.methods.objects.multiply.input2 === 'db_properties'
                      "
                      class="row"
                    >
                      <v-select
                        v-model="data.methods.objects.multiply.value2"
                        :items="data.input.db_properties.options"
                        label="No selection"
                        class="ex-dropdown"
                        item-text="text"
                        solo
                      ></v-select>
                    </div>
                    <div
                      v-if="data.methods.objects.multiply.input2 === 'string'"
                      class="row"
                    >
                      <v-text-field
                        v-model="data.methods.objects.multiply.value2"
                        placeholder="Value"
                      />
                    </div>
                  </div>
                  <div v-if="'set_variation_id' === data.methods.selection" class="row">
                    <div class="d-flex flex-column">
                      <span class="label">Source: </span>
                      <v-select
                        v-model="data.methods.objects.set_variation_id.input1"
                        :items="data.input.options"
                        label="No selection"
                        class="ex-dropdown"
                        item-text="text"
                        solo
                      ></v-select>
                      <div
                        v-if="
                          data.methods.objects.set_variation_id.input1 === 'variables'
                        "
                        class="row"
                      >
                        <v-select
                          v-model="data.methods.objects.set_variation_id.value1"
                          :items="data.input.variables.options"
                          label="No selection"
                          class="ex-dropdown"
                          item-text="text"
                          solo
                        ></v-select>
                      </div>
                      <div
                        v-if="
                          data.methods.objects.set_variation_id.input1 === 'db_properties'
                        "
                        class="row"
                      >
                        <v-select
                          v-model="data.methods.objects.set_variation_id.value1"
                          :items="data.input.db_properties.options"
                          label="No selection"
                          class="ex-dropdown"
                          item-text="text"
                          solo
                        ></v-select>
                      </div>
                      <div
                        v-if="data.methods.objects.set_variation_id.input1 === 'string'"
                        class="row"
                      >
                        <v-text-field
                          v-model="data.methods.objects.set_variation_id.value1"
                          placeholder="Value"
                        />
                      </div>
                      <div class="row" >
                        <v-select
                          v-model="data.methods.objects.set_variation_id.eval"
                          :items="data.input.eval.options"
                          label="No selection"
                          class="ex-dropdown"
                          item-text="text"
                          solo
                        ></v-select>
                        <v-text-field
                          v-model="data.methods.objects.set_variation_id.static"
                          outlined
                          color="red"
                          class="ex-dropdown"
                        ></v-text-field>
                      </div>
                      <span class="label">Variation: </span>
                      <v-select
                        v-model="data.methods.objects.set_variation_id.variation_id"
                        :items="data.input.variations.options"
                        label="Variation"
                        class="ex-dropdown"
                        item-text="text"
                        item-value="id"
                        solo
                      ></v-select>
                    </div>
                  </div>
                  <div v-if="data.methods.selection === 'division'" class="row">
                    <span class="label">Source: </span>
                    <v-select
                      v-model="data.methods.objects.division.input1"
                      :items="data.input.options"
                      label="No selection"
                      class="ex-dropdown"
                      item-text="text"
                      solo
                    ></v-select>
                    <div
                      v-if="
                        data.methods.objects.division.input1 === 'variables'
                      "
                      class="row"
                    >
                      <v-select
                        v-model="data.methods.objects.division.value1"
                        :items="data.input.variables.options"
                        label="No selection"
                        class="ex-dropdown"
                        item-text="text"
                        solo
                      ></v-select>
                    </div>
                    <div
                      v-if="
                        data.methods.objects.division.input1 === 'db_properties'
                      "
                      class="row"
                    >
                      <v-select
                        v-model="data.methods.objects.division.value1"
                        :items="data.input.db_properties.options"
                        label="No selection"
                        class="ex-dropdown"
                        item-text="text"
                        solo
                      ></v-select>
                    </div>
                    <div
                      v-if="data.methods.objects.division.input1 === 'string'"
                      class="row"
                    >
                      <v-text-field
                        v-model="data.methods.objects.division.value1"
                        placeholder="Value"
                      />
                    </div>
                    <span class="label">Division By: </span>
                    <v-select
                      v-model="data.methods.objects.division.input2"
                      :items="data.input.options"
                      label="No selection"
                      class="ex-dropdown"
                      item-text="text"
                      solo
                    ></v-select>
                    <div
                      v-if="
                        data.methods.objects.division.input2 === 'variables'
                      "
                      class="row"
                    >
                      <v-select
                        v-model="data.methods.objects.division.value2"
                        :items="data.input.variables.options"
                        label="No selection"
                        class="ex-dropdown"
                        item-text="text"
                        solo
                      ></v-select>
                    </div>
                    <div
                      v-if="
                        data.methods.objects.division.input2 === 'db_properties'
                      "
                      class="row"
                    >
                      <v-select
                        v-model="data.methods.objects.division.value2"
                        :items="data.input.db_properties.options"
                        label="No selection"
                        class="ex-dropdown"
                        item-text="text"
                        solo
                      ></v-select>
                    </div>
                    <div
                      v-if="data.methods.objects.division.input2 === 'string'"
                      class="row"
                    >
                      <v-text-field
                        v-model="data.methods.objects.division.value2"
                        placeholder="Value"
                      />
                    </div>
                  </div>
                  <div v-if="data.methods.selection === 'round'" class="row">
                    <span class="label">Source: </span>
                    <v-select
                      v-model="data.methods.objects.round.input1"
                      :items="data.input.options"
                      label="No selection"
                      class="ex-dropdown"
                      item-text="text"
                      solo
                    ></v-select>
                    <div
                      v-if="data.methods.objects.round.input1 === 'variables'"
                      class="row"
                    >
                      <v-select
                        v-model="data.methods.objects.round.value1"
                        :items="data.input.variables.options"
                        label="No selection"
                        class="ex-dropdown"
                        item-text="text"
                        solo
                      ></v-select>
                    </div>
                    <div
                      v-if="
                        data.methods.objects.round.input1 === 'db_properties'
                      "
                      class="row"
                    >
                      <v-select
                        v-model="data.methods.objects.round.value1"
                        :items="data.input.db_properties.options"
                        label="No selection"
                        class="ex-dropdown"
                        item-text="text"
                        solo
                      ></v-select>
                    </div>
                    <v-text-field
                      v-model="data.methods.objects.round.precision"
                      placeholder="Precision"
                    />
                  </div>
                  <div v-if="data.methods.selection === 'addition'" class="row">
                    <span class="label">Source: </span>
                    <v-select
                      v-model="data.methods.objects.addition.input1"
                      :items="data.input.options"
                      label="No selection"
                      class="ex-dropdown"
                      item-text="text"
                      solo
                    ></v-select>
                    <div
                      v-if="
                        data.methods.objects.addition.input1 === 'variables'
                      "
                      class="row"
                    >
                      <v-select
                        v-model="data.methods.objects.addition.value1"
                        :items="data.input.variables.options"
                        label="No selection"
                        class="ex-dropdown"
                        item-text="text"
                        solo
                      ></v-select>
                    </div>
                    <div
                      v-if="
                        data.methods.objects.addition.input1 === 'db_properties'
                      "
                      class="row"
                    >
                      <v-select
                        v-model="data.methods.objects.addition.value1"
                        :items="data.input.db_properties.options"
                        label="No selection"
                        class="ex-dropdown"
                        item-text="text"
                        solo
                      ></v-select>
                    </div>
                    <span class="label">Addition By: </span>
                    <v-select
                      v-model="data.methods.objects.addition.input2"
                      :items="data.input.options"
                      label="No selection"
                      class="ex-dropdown"
                      item-text="text"
                      solo
                    ></v-select>
                    <div
                      v-if="
                        data.methods.objects.addition.input2 === 'variables'
                      "
                      class="row"
                    >
                      <v-select
                        v-model="data.methods.objects.addition.value2"
                        :items="data.input.variables.options"
                        label="No selection"
                        class="ex-dropdown"
                        item-text="text"
                        solo
                      ></v-select>
                    </div>
                    <div
                      v-if="
                        data.methods.objects.addition.input2 === 'db_properties'
                      "
                      class="row"
                    >
                      <v-select
                        v-model="data.methods.objects.addition.value2"
                        :items="data.input.db_properties.options"
                        label="No selection"
                        class="ex-dropdown"
                        item-text="text"
                        solo
                      ></v-select>
                    </div>
                  </div>
                  <div
                    v-if="data.methods.selection === 'subtract'"
                    class="row"
                  >
                    <span class="label">Source: </span>
                    <v-select
                      v-model="data.methods.objects.subtract.input1"
                      :items="data.input.options"
                      label="No selection"
                      class="ex-dropdown"
                      item-text="text"
                      solo
                    ></v-select>
                    <div
                      v-if="data.methods.objects.subtract.input1 === 'variables'"
                      class="row"
                    >
                      <v-select
                        v-model="data.methods.objects.subtract.value1"
                        :items="data.input.variables.options"
                        label="No selection"
                        class="ex-dropdown"
                        item-text="text"
                        solo
                      ></v-select>
                    </div>
                    <div
                      v-if="data.methods.objects.subtract.input1 === 'db_properties'"
                      class="row"
                    >
                      <v-select
                        v-model="data.methods.objects.subtract.value1"
                        :items="data.input.db_properties.options"
                        label="No selection"
                        class="ex-dropdown"
                        item-text="text"
                        solo
                      ></v-select>
                    </div>
                    <span class="label">Subtract By: </span>
                    <v-select
                      v-model="data.methods.objects.subtract.input2"
                      :items="data.input.options"
                      label="No selection"
                      class="ex-dropdown"
                      item-text="text"
                      solo
                    ></v-select>
                    <div
                      v-if="data.methods.objects.subtract.input2 === 'variables'"
                      class="row"
                    >
                      <v-select
                        v-model="data.methods.objects.subtract.value2"
                        :items="data.input.variables.options"
                        label="No selection"
                        class="ex-dropdown"
                        item-text="text"
                        solo
                      ></v-select>
                    </div>
                    <div
                      v-if="data.methods.objects.subtract.input2 === 'db_properties'"
                      class="row"
                    >
                      <v-select
                        v-model="data.methods.objects.subtract.value2"
                        :items="data.input.db_properties.options"
                        label="No selection"
                        class="ex-dropdown"
                        item-text="text"
                        solo
                      ></v-select>
                    </div>
                  </div>
                  <div
                    v-if="data.methods.selection === 'Find_parent_of_string'"
                    class="row"
                  >
                    <span class="label">Source: </span>
                    <v-select
                      v-model="
                        data.methods.objects.find_parent_of_string.input1
                      "
                      :items="data.input.options"
                      label="No selection"
                      class="ex-dropdown"
                      item-text="text"
                      solo
                    ></v-select>
                    <div
                      v-if="
                        data.methods.objects.find_parent_of_string.input1 ===
                        'variables'
                      "
                      class="row"
                    >
                      <v-select
                        v-model="
                          data.methods.objects.find_parent_of_string.value1
                        "
                        :items="data.input.variables.options"
                        label="No selection"
                        class="ex-dropdown"
                        item-text="text"
                        solo
                      ></v-select>
                    </div>
                    <div
                      v-if="
                        data.methods.objects.find_parent_of_string.input1 ===
                        'db_properties'
                      "
                      class="row"
                    >
                      <v-select
                        v-model="
                          data.methods.objects.find_parent_of_string.value1
                        "
                        :items="data.input.db_properties.options"
                        label="No selection"
                        class="ex-dropdown"
                        item-text="text"
                        solo
                      ></v-select>
                    </div>
                    <v-col cols="12" sm="12">
                      <span class="label">Parent: </span>
                      <v-text-field
                        v-model="
                          data.methods.objects.find_parent_of_string.parent
                        "
                        placeholder="Value"
                      />
                    </v-col>
                    <v-col cols="12" sm="12">
                      <span class="label">String to search: </span>
                      <v-text-field
                        v-model="
                          data.methods.objects.find_parent_of_string
                            .searchstring
                        "
                        placeholder="Value"
                      />
                    </v-col>
                  </div>
                  <div
                    v-if="data.methods.selection === 'find_and_replace'"
                    class="row"
                  >
                    <span class="label">Source: </span>
                    <v-select
                      v-model="data.methods.objects.find_and_replace.input1"
                      :items="data.input.options"
                      label="No selection"
                      class="ex-dropdown"
                      item-text="text"
                      solo
                    ></v-select>
                    <div
                      v-if="
                        data.methods.objects.find_and_replace.input1 ===
                        'variables'
                      "
                      class="row"
                    >
                      <v-select
                        v-model="data.methods.objects.find_and_replace.value1"
                        :items="data.input.variables.options"
                        label="No selection"
                        class="ex-dropdown"
                        item-text="text"
                        solo
                      ></v-select>
                    </div>
                    <div
                      v-if="
                        data.methods.objects.find_and_replace.input1 ===
                        'db_properties'
                      "
                      class="row"
                    >
                      <v-select
                        v-model="data.methods.objects.find_and_replace.value1"
                        :items="data.input.db_properties.options"
                        label="No selection"
                        class="ex-dropdown"
                        item-text="text"
                        solo
                      ></v-select>
                    </div>
                    <v-col cols="12" sm="12">
                      <span class="label">Find: </span>
                      <v-text-field
                        v-model="
                          data.methods.objects.find_and_replace.findString
                        "
                        placeholder="Value"
                      />
                    </v-col>
                    <v-col cols="12" sm="12">
                      <span class="label">Replace: </span>
                      <v-text-field
                        v-model="
                          data.methods.objects.find_and_replace.replaceWith
                        "
                        placeholder="Value"
                      />
                    </v-col>
                  </div>
                </div>
              </div>
            </template>
          </ex-card>
        </v-card-text>
        <v-divider></v-divider>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
/* eslint-disable */
import axios from "axios";
import { AppUrl } from "../../assets/js/variables";
import JwtService from '@/assets/js/JwtService'
export default {
  name: "Logic",
  props: ["x", "y", "variables", "db_properties"],
  data: () => ({
    input: "",
    method: "",
    output: "",
    showLogicBlock: false,
    execution: [],
    my_variables: [],
  }),
  methods: {
    addExecution(name) {
      const params = {headers: { Authorization: `Bearer ${JwtService.getToken()}` }}
      var self = this;
      axios
        .post(AppUrl, {
          task: "getObject",
          payload: {
            chain: "logic",
            object: name,
            variables: self.variables,
            db_properties: self.db_properties,
          },
        }, params)
        .then(function (response) {
          self.execution.push(response.data);
        });
    },
    removeExecution(idx) {
      this.execution.splice(idx, 1);
    },
    showLogicDialog() {
      this.showLogicBlock = true;
    },
    add() {
      this.$emit("add", this.y, this.x);
    },
    remove() {
      this.$emit("remove", this.y, this.x);
    },
    addGlobalVars() {
      this.$emit(
        "addGlobalVars",
        this.y,
        this.x,
        this.my_variables,
        this.db_properties
      );
    },
    addcustomvariable(variable) {
      this.$emit("addGlobalVars", this.y, this.x, [variable]);
    },
  },
  computed: {},
  created() {},
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/selector/Logic.vue